/**
 * Resumo financeiro que o carrinho manda para o rascunho da proposta (mode=orcamento). O frete precisa ir junto:
 * antes só cupom/desconto eram repassados e o rascunho ficava sempre com frete 0, então o frete calculado e o
 * frete extra do fornecedor nunca chegavam ao pedido que o cliente abre.
 */
export interface CartFinancialSummary {
  subtotal?: number;
  freight?: number;
  total?: number;
  discount_code?: string;
  discount_value?: number;
}

export const toDraftFinancialSummary = (
  summary: CartFinancialSummary | undefined,
): { discount_code?: string; discount_value?: number; freight?: number } | undefined => {
  if (!summary) return undefined;
  return {
    discount_code: summary.discount_code,
    discount_value: summary.discount_value,
    ...(summary.freight !== undefined ? { freight: summary.freight } : {}),
  };
};
